import React, { ReactNode } from "react";
import { BsInfoCircleFill } from "react-icons/bs";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface Props {
  message: string;
}

export const Info: React.FC<Props> = ({ message }) => {
  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{message} </Tooltip>}>
      <span>
        <BsInfoCircleFill color={"#1daeef"} />
      </span>
    </OverlayTrigger>
  );
};
